import React, { useContext, useState } from "react";
import { TextField } from "@material-ui/core";
import axios from "axios";
import userAuthenticationConfig from "../../../utils/userAuthenticationConfig";
import { HTTP_STATUSES, STANDARD_ERRORS_WAY } from "../../../utils/consts";
import { parseAxiosError } from "../../../utils/response";
import { nickname } from "../../../rbac-consts";
import Can from "../../can/Can";
import { AppContext } from "../../../App";
import { StyledClientsEditNickname } from "../../clients/styledClients";

const NicknameFormItem = ({ client, t, notification, setNotification }) => {

  const { user } = useContext(AppContext);

  const [isEdit, setIsEdit] = useState(false);
  const [currentNickname, setCurrentNickname] = useState(client.nickname);

  const save = () => {
    axios.put("/api/users/change-nickname/" + client.id, { nickname: client.nickname }, userAuthenticationConfig()).then(response => {
      if (response.status === HTTP_STATUSES.HTTP_OK) {
        setCurrentNickname(client.nickname);

        setIsEdit(false);

        setNotification({ ...notification, visible: true, type: "success", message: t("nicknameForm.successEdit") });
      }
    }).catch(error => {
      client.nickname = currentNickname;
      parseAxiosError(eval(STANDARD_ERRORS_WAY), notification, setNotification);
    });
  };

  const renderMainForm = () => {
    return (
      <StyledClientsEditNickname>
        {isEdit ? (
          <div className="nickname-edit-form stop-event">
            <TextField
              id={`nickname.${client.id}`}
              defaultValue={client.nickname ?? ""}
              onChange={(data) => {client.nickname = data.target.value;}}
            />
            <div className="nickname-edit-form__actions">
              <button
                className="table-action"
                onClick={save}
              >
                <span className="icon-light-check" />
                {t("table.nickName.save")}
              </button>
              <button
                className="table-action table-action_danger"
                onClick={() => {
                  setIsEdit(false);
                  client.nickname = currentNickname;
                }}
              >
                <span className="icon-light-cancel" />
                {t("table.nickName.cancel")}
              </button>
            </div>
          </div>
        ) : (
          <div className="nickname-edit">
            <b>{client.nickname ?? t("table.empty")}</b>
            <button
              className="table-action table-action_info stop-event"
              onClick={() => setIsEdit(true)}
            >
              <span className="icon-light-edit" />
              {t("table.nickName.edit")}
            </button>
          </div>
        )}
      </StyledClientsEditNickname>
    );
  };

  return (
    <>
      <Can
        role={user.roles}
        perform={nickname.CHANGE}
        yes={() => renderMainForm()}
        no={() => (
          <div>{client.nickname ?? t("table.empty")}</div>
        )}
      />
    </>
  );
};

export default NicknameFormItem;